module.exports = __webpack_public_path__ + "assets/img/Type E (3).28c2fc93.jpg";